import { useEffect } from 'react';
import { SITE } from '../config/site';

// Sets the browser tab title and the meta description for a page. Each public page has its own, which is what
// search results and shared links show.
const usePageTitle = (title, description) => {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE.name}` : `${SITE.name}: ${SITE.tagline}`;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }
  }, [title, description]);
};

export default usePageTitle;
